// extracted by mini-css-extract-plugin
export default {"infoItem":"InfoItem_infoItem__jEQW1","icon":"InfoItem_icon__1S5TQ","titleAndText":"InfoItem_titleAndText__CFY+y"};